import { toast } from '@webapp/components/Notification'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useQueryDetailedCard } from '../../models/useQueryDetailedCard'

export const useGetDetailedCardPresenter = ({
  externalId,
  enabled = true,
}: {
  externalId: string
  enabled?: boolean
}) => {
  const intl = useProcurifyIntl()

  const { detailedCard, isFetching, refetch } = useQueryDetailedCard({
    externalId,
    enabled,
    onError: () => {
      toast.error({
        title: intl.formatMessage(messages.errorFetchingCardToastTitle),
      })
    },
  })

  return {
    data: {
      detailedCard,
    },
    commands: {
      refetch,
    },
    states: {
      isFetching,
    },
  }
}
